export interface ObjectNavigationData {
  title: string;
  path: string;
  icon?: string;
  toDjango?: boolean;
  toPlan?: boolean;
  tooltip?: string;
}

const objectNavigationData: ObjectNavigationData[] = [
  {
    title: 'ObjectNav.objectNav.traps',
    path: '/object/traps',
    icon: 'ri-scan-2-fill',
  },
  {
    title: 'ObjectNav.objectNav.interactiveMap',
    path: '/object/interactive-map',
    icon: 'ri-map-pin-fill',
    tooltip: 'ObjectNav.objectNav.interactiveMapTooltip',
  },
  {
    title: 'ObjectNav.objectNav.monitorings',
    path: '/object/monitorings',
    icon: 'ri-slideshow-fill',
  },
  {
    title: 'ObjectNav.objectNav.encounters',
    path: '/object/encounters',
    icon: 'ri-footprint-fill',
  },
  {
    title: 'ObjectNav.objectNav.vulnerabilities',
    path: '/object/vulnerabilities',
    icon: 'ri-alert-fill',
  },
  {
    title: 'ObjectNav.objectNav.analytics',
    path: '/object/analitics',
    icon: 'ri-line-chart-fill',
  },
  {
    title: 'ObjectNav.objectNav.reports',
    path: '/object/visits-and-scheduled-tasks',
    icon: 'ri-file-paper-2-fill',
  },
  {
    title: 'ObjectNav.objectNav.documents',
    path: '/object/docs',
    icon: 'ri-file-pdf-fill',
  },
  // {
  //   title: 'ObjectNav.objectNav.visitSchedule',
  //   path: '/visits_report_list',
  //   icon: 'ri-history-fill',
  //   toDjango: true,
  // },
];

export default objectNavigationData;
